import Icon from 'veui/components/Icon'
import { IconFileError } from 'dls-icons-vue'

Icon.register('file-error', IconFileError)
